'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weekAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/weekAgo.js
// module id = 748
// module chunks = 0